import React, {useRef, useEffect, useState} from "react";
import { useTranslate } from 'react-redux-multilingual'

const BipeurInput = (props) =>{
    const t =useTranslate()
    const bipeurInput = useRef('')

    const handleChange = (e) =>{
        if (props.error) {
            props.setError(false)
        }
        props.setBipeurVal(e.target.value.replace(/\D/g,''))
    }

    const handleClick = () =>{
        if (props.bipeur_field && props.bipeur_required && props.bipeurVal=='') {
            props.setError(true)
        }
        else if (props.bipeur_field) {
            props.editBipeurNumber()
        }
    }

    useEffect(function () {
        if (props.error) {
            bipeurInput.current.focus()
        }
    },[props.error])

    return(
        <div className={(props.isFor=='payment') ? "mt-3 d-flex align-items-center" : ""}>
            <label className='me-2' style={{ whiteSpace: 'nowrap' }}>{t('bipeurNumber') + ' : '}</label>
            <input className={'me-2 ' + ((props.error) ? 'form-control is-invalid' : 'form-control')} type="text" ref={bipeurInput} value={props.bipeurVal} onChange={(e)=>handleChange(e)}/>
            {(props.showButton) && 
                <button className="btn btn-sm btn-primary mt-2" onClick={()=>handleClick()}>{(props.loading) ? <div className="spinner-border spinner-border-sm"></div> : t('edit')}</button>
            }
        </div>
    )
}

export default BipeurInput;